if (!customElements.get('gift-wrap')) {
  class GiftWrap extends HTMLElement {
    constructor() {
      super();
      this.variantId = this.dataset.variantId;
      this.checkbox = this.querySelector('[data-gift-checkbox]');
      this.message = this.querySelector('[data-gift-message]');

      if (this.checkbox) {
        this.checkbox.addEventListener('change', this.onToggle.bind(this));
      }
      if (this.message) {
        this.message.addEventListener('input', debounce(this.onMessageInput.bind(this), 500));
      }
    }

    getSectionsToRender() {
      return (typeof sectionsToRender !== 'undefined') ? sectionsToRender : [];
    }

    clearLoading() {
      document.querySelectorAll('cart-items, cart-drawer-items').forEach(el => el.classList.remove('is-loading'));
    }

    setLoading(state) {
      if (state) {
        const container = this.closest('cart-items') || this.closest('cart-drawer-items');
        if (container) container.classList.add('is-loading');
      } else {
        this.clearLoading();
      }
    }

    onToggle() {
      const reveal = this.querySelector('[data-gift-reveal]');
      if (this.checkbox.checked) {
        if (reveal) reveal.hidden = false;
        this.addGiftWrap();
      } else {
        if (reveal) reveal.hidden = true;
        this.removeGiftWrap();
      }
    }

    addGiftWrap() {
      this.setLoading(true);
      const sections = this.getSectionsToRender();
      fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: this.variantId, quantity: 1 }],
          sections: sections.map(s => s.section),
          sections_url: window.location.pathname
        })
      })
        .then(r => r.json())
        .then(state => {
          this.renderSections(state.sections);
          this.afterUpdate();
        })
        .catch(() => { this.checkbox.checked = false; })
        .finally(() => this.setLoading(false));
    }

    removeGiftWrap() {
      this.setLoading(true);
      const sections = this.getSectionsToRender();
      fetch(`${routes.cart_change_url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: this.variantId,
          quantity: 0,
          sections: sections.map(s => s.section),
          sections_url: window.location.pathname
        })
      })
        .then(r => r.json())
        .then(state => {
          this.renderSections(state.sections);
          this.afterUpdate();
        })
        .catch(() => { this.checkbox.checked = true; })
        .finally(() => this.setLoading(false));
    }

    onMessageInput() {
      fetch(`${routes.cart_update_url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          attributes: { 'Gift wrapping message': this.message.value }
        })
      });
    }

    renderSections(sections) {
      if (!sections) return;
      this.getSectionsToRender().forEach(section => {
        const el = document.querySelector(section.selector) || document.querySelector(section.id);
        if (el && sections[section.section]) {
          el.innerHTML = new DOMParser()
            .parseFromString(sections[section.section], 'text/html')
            .querySelector(section.selector).innerHTML;
        }
      });
    }

    afterUpdate() {
      if (typeof updateCartCounters === 'function') updateCartCounters();
      if (typeof updateFreeShipping === 'function') updateFreeShipping();
      if (typeof handleCartInputNames === 'function') handleCartInputNames();
    }
  }
  customElements.define('gift-wrap', GiftWrap);
}